//Al pasar el icono pasarlo con esta clase aria-hidden="true" className="h-5 w-5 text-gray-400"

import { ExclamationCircleIcon } from "@heroicons/react/20/solid";
import { FC, Fragment, InputHTMLAttributes } from "react";

export type InputWithLeadingIconprops =
  InputHTMLAttributes<HTMLInputElement> & {
    label: string;
    span: string;
    icon: React.ReactNode;
    error?: boolean;
    textDescribe?: string;
    textError?: string;
  };

export const InputWithLeadingIcon: FC<InputWithLeadingIconprops> = ({
  label,
  span,
  icon,
  error,
  textDescribe,
  textError,
  ...props
}) => {
  return (
    <Fragment>
      <div>
        <div className="flex justify-between">
          <label
            htmlFor={props.id}
            className="block text-sm font-medium leading-6 text-gray-900"
          >
            {label}
          </label>
          <span
            aria-describedby={props.id}
            className={`text-sm leading-6 text-gray-500`}
          >
            {span}
          </span>
        </div>

        <div className="relative rounded-md shadow-sm">
          {/* Icono con los estilos que solicitaste */}
          <div className="pointer-events-none absolute inset-y-0 left-0 flex items-center pl-3">
            <span aria-hidden="true" className="h-5 w-5 text-gray-400">
              {icon}
            </span>
          </div>

          {/* Input con estilos condicionales de error */}
          <input
            {...props}
            className={`block w-full rounded-md border-0 py-1.5 pl-10 text-gray-900 shadow-sm ring-1 ring-inset ${
              error
                ? "ring-red-300 placeholder:text-red-300"
                : "ring-gray-300 placeholder:text-gray-400"
            } focus:ring-2 focus:ring-inset ${
              error ? "focus:ring-red-500" : "focus:ring-primary-600"
            } disabled:cursor-not-allowed disabled:bg-gray-100 disabled:text-gray-500 disabled:ring-gray-200 sm:text-sm sm:leading-6`}
          />

          {/* Mostrar icono de error si hay un error */}
          {error && (
            <div className="pointer-events-none absolute inset-y-0 right-0 flex items-center pr-3">
              <ExclamationCircleIcon
                aria-hidden="true"
                className="h-5 w-5 text-red-500"
              />
            </div>
          )}
        </div>

        {/* Mensaje de error */}
        {error && <p className="mt-1 text-sm text-red-600">{textError}</p>}

        {/* Descripción */}
        {textDescribe && (
          <p className="mt-1 text-sm text-gray-400">{textDescribe}</p>
        )}
      </div>
    </Fragment>
  );
};
